import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps, createSlots as _createSlots, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb2f9ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_label = _resolveComponent("ms-label")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.cssCls)
  }, [
    _createVNode(_component_ms_label, {
      style: _normalizeStyle(_ctx.labelStyle),
      required: !_ctx.allowBlank
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["style", "required"]),
    _createVNode(_component_el_select, _mergeProps(_ctx.$attrs, {
      "default-first-option": "",
      ref: "select",
      multiple: _ctx.multiple,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      loading: _ctx.loadingStatus,
      onChange: _ctx.onChange,
      onFocus: _ctx.onFocus,
      onScroll: _ctx.onScroll,
      filterable: _ctx.filterable,
      "popper-class": _ctx.popperClass,
      remote: _ctx.remote,
      "remote-method": _ctx.remoteMethod,
      "same-width": _ctx.sameWidth
    }), _createSlots({
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeItems, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item[_ctx.valueField],
            value: item[_ctx.valueField],
            "data-title": item[_ctx.displayField],
            label: item[_ctx.displayField],
            "inline-style": _ctx.optionInlineStyle,
            class: _normalizeClass(item[_ctx.classOption])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", { item: item }, undefined, true)
            ]),
            _: 2
          }, 1032, ["value", "data-title", "label", "inline-style", "class"]))
        }), 128))
      ]),
      _: 2
    }, [
      _renderList(_ctx.scopedSlots, (index, name) => {
        return {
          name: name,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, name, {}, undefined, true)
          ])
        }
      })
    ]), 1040, ["multiple", "modelValue", "loading", "onChange", "onFocus", "onScroll", "filterable", "popper-class", "remote", "remote-method", "same-width"]),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "error-msg",
          innerHTML: _ctx.errorMessage
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}